window.addEventListener("load", () => {
	// Counter
	function counter(el, start, end, duration) {
		let current = start,
		range = end - start,
		increment = end > start ? 0.1 : -0.1,
		step = Math.abs(Math.floor(duration / range)),
		timer = setInterval(() => {
			current += increment;
			el.textContent = current.toFixed(1);

			if (current >= end) {
				clearInterval(timer);
			}
		}, step);
	}

	const targetElement = document.querySelector('.before-after');

	const options = {
		root: null,
		rootMargin: '0px',
		threshold: 0.5
	};

	// Callback function to be executed when the element's visibility changes
	function handleIntersection(entries, observer) {
		entries.forEach(entry => {
			if (entry.isIntersecting) {
				document.querySelectorAll('.js-block-percent').forEach(item => {
					let end = item.textContent * 1;
			  
					counter(item, 0, end, 100);
					observer.disconnect();
				})
			}
		});
	}

	// Create the Intersection Observer instance
	const observer = new IntersectionObserver(handleIntersection, options);

	// Start observing the target element
	observer.observe(targetElement);

	//Comparation 2 images
	if (document.querySelector('section .ba__image-slide--comparation')) {
		function imageWidth() {
			let wrapperWidth = document.querySelector('.ba__image-slide-wrapper').offsetWidth;
			let sliderWidth = wrapperWidth + 'px';
			let height = wrapperWidth * .99;

			document.querySelectorAll('.ba__image-slide-wrapper .ba__image--comparation').forEach(image => {
				image.style.width = sliderWidth;
				image.style.height = 'auto';      
			});
		}

		imageWidth();

		//Adjust width of image on resize 
		window.addEventListener('resize', function() {
			imageWidth()
		})

		const resizer = document.querySelectorAll('.ba__image-scroller');
		let slideWrapper = document.querySelectorAll('.ba__image-slide-wrapper');

		let active = false;

		resizer.forEach(item => {
			item.addEventListener('mousedown',function(){
				active = true;
			})

			item.addEventListener('touchstart',function(){
				active = true;
			});
		});

		slideWrapper.forEach(item => {
			item.addEventListener('mouseup',function(){
				active = false;
			});

			item.addEventListener('mouseleave', function() {
				active = false;
			});

			item.addEventListener('touchend',function(){
				active = false;
			});

			item.addEventListener('touchcancel',function(){
				active = false;
			});

			item.addEventListener('mousemove', function(e){
				if (!active) return;
				let x = e.pageX;
				x -= item.getBoundingClientRect().left;
				slideIt(x);
				pauseEvent(e);
			});

			item.addEventListener('touchmove',function(e){
				if (!active) return;
				let x;
				let i;
				for (i=0; i < e.changedTouches.length; i++) {
					x = e.changedTouches[i].pageX; 
				}

				x -= item.getBoundingClientRect().left;
				slideIt(x);
				pauseEvent(e);
			});
		});

		function slideIt(x){
			let slider = document.querySelector('.ba__image-slide-wrapper');
			let elAfter = document.querySelector('.ba__image-slide-after');
			let transform = Math.max(0,(Math.min(x,slider.offsetWidth)));
			let scroller = document.querySelector('.ba__image-scroller');
			elAfter.style.width = transform +"px";
			scroller.style.left = transform - 0+"px";
		}

		//stop divs being selected.
		function pauseEvent(e){
			if(e.stopPropagation) e.stopPropagation();
			// if(e.preventDefault) e.preventDefault();
			e.cancelBubble = true;
			e.returnValue = false;
			return false;
		}
	}
}, false);